export const mentionsMeFilter = "LUmzrb";
export default {mentionsMeFilter};